import localeMessageBox from '@/components/message-box/locale/zh-CN';
import localeLogin from '@/views/login/locale/zh-CN';

import localeWorkplace from '@/views/dashboard/workplace/locale/zh-CN';

import localeMonitor from '@/views/dashboard/monitor/locale/zh-CN';

import localeFollowUp from '@/views/follow-up/list/locale/zh-CN';

import localeCustomer from '@/views/customer/locale/zh-CN';

import localeReport from '@/views/report/locale/zh-CN';

import localeSettings from './zh-CN/settings';

import localeTable from './zh-CN/table';

import localeForm from './zh-CN/form';

export default {
  'menu.dashboard': '仪表盘',
  'menu.followUpManagement': '回访管理',
  'menu.todayFollowUp': '今日回访',
  'menu.expiredFollowUp': '逾期回访',
  'menu.followUpHistory': '回访记录',
  'menu.clientManage': '客资管理',
  'menu.assignedCustomer': '辅助客户',
  'menu.opsCustomer': '运营客资',
  'menu.myCustomer': '我的客户',
  'menu.publicCustomer': '客户池',
  'menu.publicCustomer.unDistributed': '未分配客户',
  'menu.publicCustomer.distributed': '已分配客户',
  'menu.report': '客户报备',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,
  ...localeMonitor,
  ...localeFollowUp,
  ...localeCustomer,
  ...localeReport,
  ...localeTable,
  ...localeForm,
};
